import React, {useState} from 'react'
import './styles.scss';
import { isMobile } from '../../../helpers/Mobile';
import { useHistory } from 'react-router-dom';
import useRequest from '../../../hooks/useRequest';

import { AuthService } from '../../../services/AuthService';
import User from "../../../models/User";
import Icon from "../Icon";
import InputText from "../InputText";
import GradientButton from "../GradientButton";
import InputCheckbox from '../InputCheckbox';
import {UserService} from "../../../services/UserService";

const ChangePassword =  (props) => {

    const [clave, setClave] = useState("");
    const [claveConfirmacion, setClaveConfirmacion] = useState("");
    const [showPass, setshowPass] = useState(false);

    const {
        submitted, success, message,
        beforeSubmit,
    } = useRequest();

    const handleSubmit = (e) => {
        e.preventDefault();
        beforeSubmit();
        console.log('ChangePassowrdo');
        console.log(props);
        const data = {
            password: clave,
            password_confirmation: claveConfirmacion
        }
        props.handleSubmit(data);
    }


return (
    <div className="change-password-container">
        <div className="change-password-content">
            <form className="change-password-form" onSubmit={handleSubmit}>
                <h1 className="change-password-title">Cambiar contraseña</h1>
                <div className="change-password-input-group">
                    <div className="change-password-input-container">
                        <InputText label={"Nueva contraseña"} id="password" placeholder="Nueva contraseña"
                            handleChange={(event) => { setClave(event.target.value) }} type={showPass ? 'text' : 'password'} error={props.error ? props.error.password : []}/>
                        <div className={showPass ? 'register-eye show' : 'register-eye hide'} onClick={() => { setshowPass(false) }}>
                            <Icon name="eye" width={26} height={17} fill={isMobile ? '#ffffff' : '#1F3BA3'} />
                        </div>
                        <div className={showPass ? 'register-eye-closed hide' : 'register-eye show'} onClick={() => { setshowPass(true) }}>
                            <Icon name="eye-closed" width={26} height={17} fill={isMobile ? '#ffffff' : '#1F3BA3'} />
                        </div>
                    </div>
                </div>
                <div className="change-password-input-group">
                    <div className="change-password-input-container">
                        <InputText label={"Repetir nueva contraseña"} id="password" placeholder="Repetir nueva contraseña"
                            handleChange={(event) => { setClaveConfirmacion(event.target.value) }} type={showPass ? 'text' : 'password'} error={props.error ? props.error.password_confirmation : []}/>
                        <div className={showPass ? 'register-eye show' : 'register-eye hide'} onClick={() => { setshowPass(false) }}>
                            <Icon name="eye" width={26} height={17} fill={isMobile ? '#ffffff' : '#1F3BA3'} />
                        </div>
                        <div className={showPass ? 'register-eye-closed hide' : 'register-eye show'} onClick={() => { setshowPass(true) }}>
                            <Icon name="eye-closed" width={26} height={17} fill={isMobile ? '#ffffff' : '#1F3BA3'} />
                        </div>
                    </div>
                </div>
                {(success === false && message) &&
                    <p className="error-messages">{message}</p>
                }
                <div className="change-password-button">
                    <GradientButton legend={'CAMBIAR'} disabled={submitted}
                                    handleClick={handleSubmit} type={'submit'} />
                </div>
            </form>
        </div>
    </div>
);
}

export default ChangePassword;